import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import { DialogProgrammatic as Dialog } from "buefy";
import { handleFileDownload } from "../utils/fileDownloadHelper";
import env from "../environment/env.json";

export interface CustomerUpdateData {
  id: number;
  message: string;
  subject: string;
  recipient_type: string;
  customer_type: string;
}

export class CustomerUpdatesDataService {
  private httpClient = makeHttpClient();

  getAll(query: any, sent: any) {
    let url = "/notifications/view/customer/updates/?sent=" + sent;
    if (query) {
      url = url + "&" + query;
    }
    return _unwrapAxiosResponse(this.httpClient.get<CustomerUpdateData[]>(url));
  }

  getAllSent(id: any) {
    // const url = env.customerUpdatesUrl + "sent/"
    const url = `${env.customerUpdatesUrl}${id}/sent`;

    return _unwrapAxiosResponse(this.httpClient.get<CustomerUpdateData[]>(url));
  }

  exportProofOfSubmission(id: number, file: any) {
    const fileName = file.attachment || file.name;
    const url = `${
      env.customerUpdatesUrl
    }get/document?id=${id}&attachment=${encodeURIComponent(fileName)}`;

    return handleFileDownload(
      this.httpClient,
      url,
      fileName,
      "Export not possible",
      "There was an error exporting proof of submission. Please contact your Customer Account Manager."
    );
  }

  exportgetData(id: number) {
    const url = `${env.customerUpdatesUrl}get/export?customer_update=` + id;
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(response => {
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data])
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "export.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(err => {
        Dialog.alert({
          title: "Export not possible",
          message:
            "There was an error exporting customer update data. Please contact your Customer Account Manager.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return err;
      });
  }
  get(id: string) {
    const url = `${env.customerUpdatesUrl}${id}`;
    return _unwrapAxiosResponse(this.httpClient.get<CustomerUpdateData>(url));
  }

  update(id: string, updateData: any, file: any) {
    const url = `${env.customerUpdatesUrl}${id}`;
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    const data = new FormData();
    if (file != null) {
      for (let i = 0; i < file.length; i++) {
        data.append("file" + i, file[i]);
      }
    }
    data.append("file", file);
    data.append("id", updateData.id);
    data.append("attachments", JSON.stringify(updateData.attachments));
    data.append("status", updateData.status);
    data.append("schemes", updateData.schemes);
    data.append("streams", updateData.streams);
    data.append("subject", updateData.subject);
    data.append("message", updateData.message);
    data.append("reports", updateData.reports);
    data.append("contacts", updateData.contacts);
    data.append("customers", updateData.customers);
    data.append("countries", updateData.countries);
    data.append("update_type", updateData.update_type);
    data.append("landbell_entity", updateData.landbell_entity);
    data.append("customer_type", updateData.customer_type);
    data.append("recipient_type", updateData.recipient_type);
    return _unwrapAxiosResponse(this.httpClient.put(url, data, headers));
  }

  post(form: any, file: any) {
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
    const data = new FormData();
    if (file != null) {
      for (let i = 0; i < file.length; i++) {
        data.append("file" + i, file[i]);
      }
    }
    data.append("file", file);
    data.append("status", form.status);
    data.append("scheme", form.schemes);
    data.append("stream", form.streams);
    data.append("subject", form.subject);
    data.append("message", form.message);
    data.append("reports", form.reports);
    data.append("contacts", form.contacts);
    data.append("countries", form.countries);
    data.append("customers", form.customers);
    data.append("update_type", form.update_type);
    data.append("landbell_entity", form.landbell_entity);
    data.append("customer_type", form.customer_type);
    data.append("recipient_type", form.recipient_type);
    return _unwrapAxiosResponse(
      this.httpClient.post<CustomerUpdateData>(
        `${env.customerUpdatesUrl}`,
        data,
        headers
      )
    );
  }

  getCustomerScopes(streamList: any, countryList: any) {
    const data = {
      streams: streamList,
      countries: countryList
    };
    const url = `/notifications/scope/`;
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  send(id: number) {
    const data = {
      pk: id
    };
    const url = `${env.customerUpdatesUrl}${id}/send`;
    return _unwrapAxiosResponse(this.httpClient.post(url, data));
  }
}

export default CustomerUpdatesDataService;
